var _desc, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "25px",
    height: "25px",
    viewBox: "0 0 25 25",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "KursOrganizer-Logo-Schriftzug") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "KursOrganizer-Logo-2",
    fill: "#1891FF",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.926,22.553c-2.076,1.537 -4.646,2.447 -7.426,2.447c-3.047,0 -5.84,-1.092 -8.01,-2.907l7.488,-7.488l7.948,7.948Zm2.167,-18.063c1.815,2.17 2.907,4.963 2.907,8.01c-0,3.313 -1.292,6.326 -3.398,8.564l-8.041,-8.042l8.532,-8.532Zm-17.34,14.174l-1.846,1.846c-1.815,-2.17 -2.907,-4.963 -2.907,-8.01c-0,-3.974 1.858,-7.517 4.753,-9.808l0,15.972Zm2.238,-17.386c1.662,-0.818 3.532,-1.278 5.509,-1.278c3.047,-0 5.84,1.092 8.01,2.907l-13.519,13.519l0,-15.148Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.be14bb94b69e2d097121775ae7ddae19.svg";
export { ForwardRef as ReactComponent };